import { makeStyles, shorthands } from '@fluentui/react-components';
import { customTokens } from 'src/utils/theme';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    width: '100%',
    position: 'relative',
    flexDirection: 'column',
  },
  progressSegment: {
    flex: 1,
  },
  progressBarsRow: {
    display: 'flex',
    width: '100%',
  },
  progressBar: {
    'width': '100%',
    'height': customTokens.spacingVerticalSNudge,
    ...shorthands.border(customTokens.strokeWidthThin, 'solid', customTokens.colorNeutralBackground1),

    '[role=progressbar]': {
      backgroundColor: customTokens.colorBrandBackgroundInvertedHover1,
    },
  },
  milestonesRow: {
    position: 'relative',
    width: '100%',
  },
  milestoneItem: {
    position: 'absolute',
    transform: 'translate(-30%, -35%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 1,
  },
  milestoneDot: {
    width: customTokens.spacingHorizontalL,
    height: customTokens.spacingVerticalL,
    backgroundColor: customTokens.colorBrandBackgroundInvertedHover2,
    borderRadius: customTokens.borderRadiusCircular,
  },
  milestoneDotReached: {
    backgroundColor: customTokens.colorCompoundBrandBackground,
  },
  firstMilestoneDot: {
    visibility: 'hidden',
  },
  milestonePoint: {
    display: 'block',
    position: 'absolute',
    lineHeight: customTokens.lineHeightBase300,
    fontSize: customTokens.fontSizeBase300,
    fontWeight: customTokens.fontWeightRegular,
    color: customTokens.colorNeutralForeground5,
    marginTop: customTokens.spacingVerticalXL,
  },
  milestonePointReached: {
    color: customTokens.colorCompoundBrandBackground,
  },
  starIconContainer: {
    position: 'absolute',
    transform: 'translate(0, -20%)',
    width: customTokens.spacingHorizontalXXL,
    height: customTokens.spacingVerticalXXL,
    backgroundColor: customTokens.colorNeutralBackground1,
    borderRadius: customTokens.borderRadiusCircular,
    ...shorthands.border(customTokens.strokeWidthThickest, 'solid', customTokens.colorStrokeFocus2),
    zIndex: 1,
  },
  starIcon: {
    color: customTokens.colorPaletteMarigoldForeground3,
  },
});
